import { type Viewer } from '@xeokit/xeokit-sdk';
import { math } from '@xeokit/xeokit-sdk/dist/xeokit-sdk.es.js';

export const useViewerZonesStore = defineStore('viewer-zones-store', () => {
  const {
    $ZonesPlugin,
    $ZonesMouseControl,
    $ZoneEditMouseControl,
    //$ZoneTranslateMouseControl
  } = useNuxtApp();
  const viewerStore = useViewerStore();
  const toolbarStore = useToolbarStore();

  const isInitialized = ref(false);
  const numberOfZones = ref(0);

  const tempAABB = math.AABB3();
  const tempVec3 = math.vec3();

  let plugin: InstanceType<typeof $ZonesPlugin> | undefined;
  let mouseControl: InstanceType<typeof $ZonesMouseControl> | undefined;
  let mouseEditControl: InstanceType<typeof $ZoneEditMouseControl> | undefined;
  //let mouseTranslateMouseControl: InstanceType<typeof $ZoneTranslateMouseControl> | undefined;

  function getPlugin() {
    return plugin;
  }

  function getMouseControl() {
    return mouseControl;
  }

  function getMouseEditControl() {
    return mouseEditControl;
  }

  function getZones() {
    const plugin = getPlugin();
    if (!plugin) return;

    return plugin.zones;
  }

  function init() {
    const viewer = viewerStore.getHelpers().viewer as Viewer;

    // // @ts-ignore
    // const _onSceneZoneCreated = viewer.scene.on('onZoneCreated', () => {
    //   console.log('onZoneCreated');
    //   updateZones();
    // });

    // const saveZonesDebounced = useDebounceFn(() => {
    //   const plugin = getPlugin();
    //   if (!plugin) return;

    //   saveZones(plugin.zones);
    // }, 1000);

    // const clearZonesDebounced = useDebounceFn(() => {
    //   const plugin = getPlugin();
    //   if (!plugin) return;

    //   saveZones(plugin.zones);
    // }, 1000);

    // @ts-ignore
    // const _onSectionPlaneUpdated = viewer.scene.on('sectionPlaneUpdated', function () {
    //   saveSectionsDebounced();
    // });

    // @ts-ignore
    // const _onSceneSectionPlaneDestroyed = viewer.scene.on('sectionPlaneDestroyed', () => {
    //   updateSectionPlanes();
    //   clearSectionsDebounced();
    // });

    if (!viewer) return;

    const pointerLens = viewerStore.getHelpers().pointerLens;

    plugin = new $ZonesPlugin(viewer);
    mouseControl = new $ZonesMouseControl(plugin, {
      pointerLens: pointerLens,
    });

    // mouseEditControl = new $ZoneEditMouseControl(plugin, {
    //   pointerLens: pointerLens,
    // });

    // mouseTranslateMouseControl = new $ZoneTranslateMouseControl(plugin, {
    //   pointerLens: pointerLens,
    // });

    plugin.on('zoneCreated', (zone) => {
      console.log('Zone created:', { zone });
    });

    mouseControl.on('zoneEnd', (zone) => {
      console.log('Zone added:', { zone });

      //mouseControl.deactivate();
      //attachZoneAnnotation(zone, "G1", "Title...", "Description...");
      updateZones();
    });

    initZonesFeatureMode();

    isInitialized.value = true;
  }

  function initZonesFeatureMode() {
    const canvasWrapperElement = document.getElementById('xeokit-wrapper') as HTMLElement;

    canvasWrapperElement.addEventListener('click', (e) => {
      if (e.button === 0) {
        if (!toolbarStore.zoneFeatureMode.active) return;

        const viewer = viewerStore.getHelpers().viewer as Viewer;
        if (!viewer) return;

        const coords = getMouseCanvasPos(e);

        console.log({ coords });
      }
    });

    updateZones();
  }

  function getNumZones(): number {
    const plugin = getPlugin();

    if (!plugin) {
      return 0;
    } else {
      return Object.keys(plugin.zones).length;
    }
  }

  function clearZones() {
    const plugin = getPlugin();
    if (!plugin) return;

    // for (const zone of plugin.zones) {
    //   zone.destroy();
    // }

    const count = Object.keys(plugin.zones).length;

    for (let i = count - 1; i >= 0; i--) {
      plugin.zones[i].destroy();
    }

    updateZones();
  }

  function enableZones() {
    const plugin = getPlugin();
    if (!plugin) return;

    const zones = plugin.zones;

    for (const zone of zones) {
      zone.visible = true;
    }
  }

  function disableZones() {
    const plugin = getPlugin();
    if (!plugin) return;

    const zones = plugin.zones;

    for (const zone of zones) {
      zone.visible = false;
    }
  }

  function hideControl() {
    const plugin = getPlugin();
    if (!plugin) return;
    plugin.hideControl();
  }

  function updateZones() {
    const plugin = getPlugin();
    if (!plugin) return;

    //zones = Object.values(plugin.zones);
    numberOfZones.value = getNumZones();
  }

  function editZone(zone) {
    const plugin = getPlugin();
    if (!plugin) return;

    const viewer = viewerStore.getHelpers().viewer;
    if (!viewer) return;

    plugin.hideControl();
    plugin.showControl(zone.id);

    const zonePos = zone.pos;
    tempAABB.set(viewer.scene.aabb);
    math.getAABB3Center(tempAABB, tempVec3);
    tempAABB[0] += zonePos[0] - tempVec3[0];
    tempAABB[1] += zonePos[1] - tempVec3[1];
    tempAABB[2] += zonePos[2] - tempVec3[2];
    tempAABB[3] += zonePos[0] - tempVec3[0];
    tempAABB[4] += zonePos[1] - tempVec3[1];
    tempAABB[5] += zonePos[2] - tempVec3[2];

    viewer.cameraFlight.flyTo({
      aabb: tempAABB,
      fitFOV: 65,
    });
  }

  function getMouseCanvasPos(event) {
    if (!event) {
      event = window.event;
      return [event.x, event.y];
    } else {
      let element = event.target;
      let totalOffsetLeft = 0;
      let totalOffsetTop = 0;
      while (element.offsetParent) {
        totalOffsetLeft += element.offsetLeft;
        totalOffsetTop += element.offsetTop;
        element = element.offsetParent;
      }
      return [event.pageX - totalOffsetLeft, event.pageY - totalOffsetTop];
    }
  }

  function saveZones(_zones: []) {
    //const { $xeovisionStorage } = useNuxtApp();
    const route = useRoute();

    if (!route.params.id) return;

    const itemKey = `${route.params.id}-zones`;

    console.log('saveZones', { itemKey });

    // const sectionsToSave: {
    //   id: string;
    //   pos: number[];
    //   dir: number[];
    //   active: boolean;
    // }[] = [];

    // for (const [key, value] of Object.entries(sectionPlanes)) {
    //   sectionsToSave.push({
    //     id: key,
    //     pos: [value.pos[0], value.pos[1], value.pos[2]],
    //     dir: [value.dir[0], value.dir[1], value.dir[2]],
    //     active: value.active,
    //   });
    // }

    // if (sectionsToSave.length === 0) {
    //   $xeovisionStorage.remomveItem(itemKey);
    // } else {
    //   $xeovisionStorage.setItem(itemKey, JSON.stringify(sectionsToSave));
    // }
  }

  function loadZones() {
    //const { $xeovisionStorage } = useNuxtApp();
    const viewerStore = useViewerStore();
    const viewer = viewerStore.getHelpers().viewer;
    const route = useRoute();

    if (!viewer || !route.params.id) return;

    //const zones = $xeovisionStorage.getItem(`${route.params.id}-zones`);

    //const plugin = getPlugin();

    console.log('loadZones');

    // if (plugin && zones) {
    //   try {
    //     JSON.parse(zones).forEach((zone) => {
    //       plugin.createSectionPlane({
    //         pos: section.pos,
    //         dir: section.dir,
    //         active: section.active,
    //       });
    //     });
    //   } catch (err) {
    //     console.log({ loadSectionsError: err });
    //   }
    // }
  }

  function contextMenuOnFocus(zone: any) {
    zone.highlighted = true;
    // const plugin = getPlugin();

    // plugin?.hideControl();
    // plugin?.showControl(zone.id);
  }

  function contextMenuOnBlur(zone: any) {
    zone.highlighted = false;
    // const plugin = getPlugin();
    // plugin?.hideControl();
  }

  return {
    numberOfZones,
    clearZones,
    enableZones,
    disableZones,
    hideControl,
    isInitialized,
    getPlugin,
    init,
    editZone,
    //zones,
    getZones,
    saveZones,
    loadZones,
    contextMenuOnFocus,
    contextMenuOnBlur,
    getMouseControl,
    getMouseEditControl,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useViewerZonesStore, import.meta.hot));
}
